<template>
  <div class="price_flow">
    <div class="overview">
      <!-- 物件名・プランID -->
      <div class="plan_name_id">
        <p>{{estimate.planName}}</p>
        <p>{{estimate.planId}}</p>
      </div>
      <!-- 計算の説明 -->
      <div class="calc_description">
        <table>
          <tr>
            <td class="a_b_c_d_e"><p>A</p><p>BOM</p><p>計算値</p></td>
            <td class="a_b_c_d_e"><p>B</p><br><p>A x %</p></td>
            <td class="a_b_c_d_e"><p>C</p><p>BOM</p><p>計算値</p></td>
            <td class="a_b_c_d_e"><p>D</p><br><p>(C) x %</p></td>
            <td class="a_b_c_d_e"><p>E</p><br><p>(C+D) x %</p></td>
            <td class="f"><p>F</p><p>任意</p><p>入力値</p></td>
            <td class="g"><p>G</p><p>(A～F)/(1-利益率)</p></td>
            <td class="h_i_j"><p>H</p><br><p>G/(1-利益率)</p></td>
            <td class="h_i_j"><p>I</p><br><p>H/(1-利益率)</p></td>
            <td class="h_i_j"><p>J</p><br><p>I/(1-利益率)</p></td>
            <td class="k_l"><p>K</p><p>任意</p><p>入力値</p></td>
            <td class="k_l"><p>L</p><p>任意</p><p>入力値</p></td>
          </tr>
        </table>
      </div>
    </div>
    <!-- テーブル -->
    <table class="list" v-if="estimate">
      <tr class="border_bottom_middle">
        <td colspan="2" width="210px" class="border_right_middle cell_setting">
          <span class="square"></span>セルに設定値を入力
        </td>
        <td colspan="5" class="border_top_middle production">生産</td>
        <td class="border_top_middle border_right_thin oem_est">OEM見積</td>
        <td class="border_top_middle border_right_middle marker-est">メーカー見積</td>
        <td colspan="3" class="border_top_middle border_right_middle distribution">流通</td>
        <td colspan="2" class="border_top_middle border_right_middle cost">費用</td>
      </tr>
      <tr class="border_bottom_thick">
        <td class="border_left_middle item">種目</td>
        <td class="border_right_middle item">別名</td>
        <td class="item">材料費</td>
        <td class="item prob">材料管理費(%)</td>
        <td class="item">加工費</td>
        <td class="item prob">生産管理費(%)</td>
        <td class="item prob">工場利益(%)</td>
        <td class="border_right_thin item">輸送賃</td>
        <td class="border_right_middle item prob">営業部門利益(%)</td>
        <td class="item prob">販社A利益(%)</td>
        <td class="item prob">販社B利益(%)</td>
        <td class="border_right_middle item prob">販社C利益(%)</td>
        <td class="item">配送費</td>
        <td class="border_right_middle item">施工費</td>
      </tr>
      <tr>
        <td class="setting_input_sub border_left_middle item"></td>
        <td class="setting_input_sub border_right_middle item"></td>
        <td class="setting_input_sub"></td>
        <td class="setting_input_sub"></td>
        <td class="setting_input_sub">分チャージ</td>
        <td class="setting_input_sub"></td>
        <td class="setting_input_sub">内掛け</td>
        <td class="setting_input_sub border_right_thin"></td>
        <td class="setting_input_sub border_right_middle">外掛け</td>
        <td class="setting_input_sub">外掛け</td>
        <td class="setting_input_sub">外掛け</td>
        <td class="setting_input_sub border_right_middle">外掛け</td>
        <td class="setting_input_sub"></td>
        <td class="setting_input_sub border_right_middle"></td>
      </tr>
      <tr>
        <td class="border_left_middle item setting_input"><font color="#305496">設定入力</font></td>
        <td class="border_right_middle item"></td>
        <td class="bom">BOM</td>
        <td class="input_area">
          <input type="number" :value="estimate.materialMagProb"
            @input="$emit('changeEstimateValue', 'materialMagProb', $event)"/>
        </td>
        <td class="input_area">
          <input type="number" :value="estimate.processCost"
             @input="$emit('changeEstimateValue', 'processCost', $event)"/>
        </td>
        <td class="input_area">
          <input type="number" :value="estimate.productMagCost"
             @input="$emit('changeEstimateValue', 'productMagCost', $event)"/>
        </td>
        <td class="input_area">
          <input type="number" :value="estimate.factoryProfit"
             @input="$emit('changeEstimateValue', 'factoryProfit', $event)"/>
        </td>
        <td class="input_area">
          <input type="number" :value="estimate.facttransCost"
             @input="$emit('changeEstimateValue', 'facttransCost', $event)"/>
        </td>
        <td class="input_area">
          <input type="number" :value="estimate.profitRate1"
             @change="$emit('changeEstimateValue', 'profitRate1', $event)"
             @keyup="$emit('changeEstimateValue', 'profitRate1', $event)"
             @input="$emit('changeEstimateValue', 'profitRate1', $event)"/>
        </td>
        <td class="input_area">
          <input type="number" :value="estimate.profitRate2"
             @input="$emit('changeEstimateValue', 'profitRate2', $event)"/>
        </td>
        <td class="input_area">
          <input type="number" :value="estimate.profitRate3"
             @input="$emit('changeEstimateValue', 'profitRate3', $event)"/>
        </td>
        <td class="input_area">
          <input type="number" :value="estimate.profitRate4"
             @input="$emit('changeEstimateValue', 'profitRate4', $event)"/>
        </td>
        <td class="input_area">
          <input type="number" :value="estimate.deliveryCost"
             @input="$emit('changeEstimateValue', 'deliveryCost', $event)"/>
        </td>
        <td class="border_right_middle input_area">
          <input type="number" :value="estimate.executionCost"
             @input="$emit('changeEstimateValue', 'executionCost', $event)"/>
        </td>
      </tr>
      <tr class="border_bottom_thin">
        <td class="border_left_middle item">項目金額</td>
        <td class="border_right_middle item"></td>
        <td>{{materialCostItemPrice}}</td>
        <td>{{materialMagProbItemPrice}}</td>
        <td>{{processCostItemPrice}}</td>
        <td>{{productMagCostItemPrice}}</td>
        <td>{{factoryProfitItemPrice}}</td>
        <td class="border_right_thin">{{facttransCostItemPrice}}</td>
        <td class="border_right_middle">{{profitRate1ItemPrice}}</td>
        <td>{{profitRate2ItemPrice}}</td>
        <td>{{profitRate3ItemPrice}}</td>
        <td class="border_right_middle">{{profitRate4ItemPrice}}</td>
        <td></td>
        <td class="border_right_middle"></td>
      </tr>
      <tr class="border_bottom_thick">
        <td class="border_left_middle item">積算金額</td>
        <td class="border_right_middle item"></td>
        <td>{{materialCostAccumulatedPrice}}</td>
        <td>{{materialMagProbAccumulatedPrice}}</td>
        <td>{{processCostAccumulatedPrice}}</td>
        <td>{{productMagCostAccumulatedPrice}}</td>
        <td>{{factoryProfitAccumulatedPrice}}</td>
        <td class="border_right_thin">{{facttransCostAccumulatedPrice}}</td>
        <td class="border_right_middle">{{profitRate1AccumulatedPrice}}</td>
        <td>{{profitRate2AccumulatedPrice}}</td>
        <td>{{profitRate3AccumulatedPrice}}</td>
        <td class="border_right_middle">{{profitRate4AccumulatedPrice}}</td>
        <td>{{deliveryCostAccumulatedPrice}}</td>
        <td class="border_right_middle">{{executionCostAccumulatedPrice}}</td>
        <td class="border_top_middle border_right_thin item">見積金額</td>
        <td class="border_top_middle item">粗利(限界利益)</td>
        <td class="border_top_middle border_right_middle item">粗利益</td>
      </tr>
      <tr class="border_bottom_thin">
        <td class="border_left_middle item">工場製造原価</td>
        <td class="border_right_middle item alias">製造原価</td>
        <td>{{materialCostItemPrice}}</td>
        <td>{{materialMagProbItemPrice}}</td>
        <td>{{processCostItemPrice}}</td>
        <td>{{productMagCostItemPrice}}</td>
        <td class="empty"></td>
        <td class="border_right_thin empty"></td>
        <td class="border_right_middle empty"></td>
        <td class="empty"></td>
        <td class="empty"></td>
        <td class="border_right_middle empty"></td>
        <td class="empty"></td>
        <td class="border_right_middle empty"></td>
        <td class="border_right_thin">{{manufacturingCost}}</td>
        <td>{{manufacturingGrossMargin}}</td>
        <td class="border_right_middle">{{manufacturingGrossProfit}}%</td>
      </tr>
      <tr class="border_bottom_thin">
        <td class="border_left_middle item">工場価格見積</td>
        <td class="border_right_middle item alias">OEM・営業仕切</td>
        <td>{{materialCostItemPrice}}</td>
        <td>{{materialMagProbItemPrice}}</td>
        <td>{{processCostItemPrice}}</td>
        <td>{{productMagCostItemPrice}}</td>
        <td>{{factoryProfitItemPrice}}</td>
        <td class="border_right_thin">{{facttransCostItemPrice}}</td>
        <td class="border_right_middle empty"></td>
        <td class="empty"></td>
        <td class="empty"></td>
        <td class="border_right_middle empty"></td>
        <td class="empty"></td>
        <td class="border_right_middle empty"></td>
        <td class="border_right_thin">{{factoryCostEst}}</td>
        <td>{{factoryGrossMargin}}</td>
        <td class="border_right_middle">{{factoryGrossProfit}}%</td>
      </tr>
      <tr class="border_bottom_middle">
        <td class="border_left_middle item">工場営業見積</td>
        <td class="border_right_middle item alias">メーカー見積 A向け</td>
        <td>{{materialCostItemPrice}}</td>
        <td>{{materialMagProbItemPrice}}</td>
        <td>{{processCostItemPrice}}</td>
        <td>{{productMagCostItemPrice}}</td>
        <td>{{factoryProfitItemPrice}}</td>
        <td class="border_right_thin">{{facttransCostItemPrice}}</td>
        <td class="border_right_middle">{{profitRate1ItemPrice}}</td>
        <td class="empty"></td>
        <td class="empty"></td>
        <td class="border_right_middle empty"></td>
        <td class="empty"></td>
        <td class="border_right_middle empty"></td>
        <td class="border_right_thin">{{factorySalesEst}}</td>
        <td>{{factorySalesEstGrossMargin}}</td>
        <td class="border_right_middle">{{factorySalesEstGrossProfit}}%</td>
      </tr>
      <tr class="border_bottom_thin">
        <td class="border_left_middle item">販社A見積</td>
        <td class="border_right_middle item alias">B向け 見積</td>
        <td>{{materialCostItemPrice}}</td>
        <td>{{materialMagProbItemPrice}}</td>
        <td>{{processCostItemPrice}}</td>
        <td>{{productMagCostItemPrice}}</td>
        <td>{{factoryProfitItemPrice}}</td>
        <td class="border_right_thin">{{facttransCostItemPrice}}</td>
        <td class="border_right_middle">{{profitRate1ItemPrice}}</td>
        <td>{{profitRate2ItemPrice}}</td>
        <td class="empty"></td>
        <td class="border_right_middle empty"></td>
        <td class="empty"></td>
        <td class="border_right_middle empty"></td>
        <td class="border_right_thin">{{salesCompanyA}}</td>
        <td>{{salesCompanyAGrossMargin}}</td>
        <td class="border_right_middle">{{salesCompanyAGrossProfit}}%</td>
      </tr>
      <tr class="border_bottom_thin">
        <td class="border_left_middle item">販社B見積</td>
        <td class="border_right_middle item alias">C向け 見積</td>
        <td>{{materialCostItemPrice}}</td>
        <td>{{materialMagProbItemPrice}}</td>
        <td>{{processCostItemPrice}}</td>
        <td>{{productMagCostItemPrice}}</td>
        <td>{{factoryProfitItemPrice}}</td>
        <td class="border_right_thin">{{facttransCostItemPrice}}</td>
        <td class="border_right_middle">{{profitRate1ItemPrice}}</td>
        <td>{{profitRate2ItemPrice}}</td>
        <td>{{profitRate3ItemPrice}}</td>
        <td class="border_right_middle empty"></td>
        <td class="empty"></td>
        <td class="border_right_middle empty"></td>
        <td class="border_right_thin">{{salesCompanyB}}</td>
        <td>{{salesCompanyBGrossMargin}}</td>
        <td class="border_right_middle">{{salesCompanyBGrossProfit}}%</td>
      </tr>
      <tr class="border_bottom_middle">
        <td class="border_left_middle item">販社C見積</td>
        <td class="border_right_middle item alias">エンドユーザー上代</td>
        <td>{{materialCostItemPrice}}</td>
        <td>{{materialMagProbItemPrice}}</td>
        <td>{{processCostItemPrice}}</td>
        <td>{{productMagCostItemPrice}}</td>
        <td>{{factoryProfitItemPrice}}</td>
        <td class="border_right_thin">{{facttransCostItemPrice}}</td>
        <td class="border_right_middle">{{profitRate1ItemPrice}}</td>
        <td>{{profitRate2ItemPrice}}</td>
        <td>{{profitRate3ItemPrice}}</td>
        <td class="border_right_middle">{{profitRate4ItemPrice}}</td>
        <td>{{estimate.deliveryCost}}</td>
        <td class="border_right_middle">{{estimate.executionCost}}</td>
        <td class="border_right_thin">{{salesCompanyC}}</td>
        <td>{{salesCompanyCGrossMargin}}</td>
        <td class="border_right_middle">{{salesCompanyCGrossProfit}}%</td>
      </tr>
    </table>

    <!-- 帯グラフ -->
    <div class="graph">
      <chart
        :chart-data="chartData"
        :options="options"
        :width="1350"
      />
    </div>
  </div>
</template>

<script>
import Chart from './Chart'
export default {
  name: 'PriceFlow',
  props: {
    estimate: null
  },
  components: {
    'chart': Chart
  },
  data () {
    return {
      // 帯グラフの設定
      options: {
        tooltips: {
          enabled: false
        },
        responsive: false,
        title: {
          display: true,
          fontSize: 20
        },
        legend: {
          position: 'bottom'
        },
        scales: {
          xAxes: [
            {
              stacked: true
            }
          ],
          yAxes: [
            {
              stacked: true
            }
          ]
        }
      }
    }
  },
  computed: {
    // *****************************************************************
    // 項目金額、積算金額
    // *****************************************************************
    // 材料費
    materialCostItemPrice: function () {
      return this.estimate.materialCost
    },
    materialCostAccumulatedPrice: function () {
      return this.materialCostItemPrice
    },
    // 材料管理費
    materialMagProbItemPrice: function () {
      return Math.round(this.materialCostItemPrice * this.estimate.materialMagProb / 100)
    },
    materialMagProbAccumulatedPrice: function () {
      return this.estimate.materialCost + this.materialMagProbItemPrice
    },
    // 加工費
    processCostItemPrice: function () {
      // 加工費+加工単価*加工時間+組立費
      return this.estimate.processCostOrigin + Math.round(this.estimate.processCost * this.estimate.processTime) + this.estimate.constructionCost
    },
    processCostAccumulatedPrice: function () {
      return this.materialMagProbAccumulatedPrice + this.processCostItemPrice
    },
    // 生産管理費
    productMagCostItemPrice: function () {
      return Math.round(this.processCostItemPrice * this.estimate.productMagCost / 100)
    },
    productMagCostAccumulatedPrice: function () {
      return this.processCostAccumulatedPrice + this.productMagCostItemPrice
    },
    // 工場利益
    factoryProfitItemPrice: function () {
      return Math.round((this.processCostItemPrice + this.productMagCostItemPrice) * this.estimate.factoryProfit / 100)
    },
    factoryProfitAccumulatedPrice: function () {
      return this.productMagCostAccumulatedPrice + this.factoryProfitItemPrice
    },
    // 輸送費
    facttransCostItemPrice: function () {
      return Number(this.estimate.facttransCost)
    },
    facttransCostAccumulatedPrice: function () {
      return this.factoryProfitAccumulatedPrice + this.facttransCostItemPrice
    },
    // 営業部門利益
    profitRate1ItemPrice: function () {
      let profitRate1Double = this.estimate.profitRate1 / 100
      // 掛率対象金額 / (1 - 掛率) - 掛率対象金額
      return Math.round(this.facttransCostAccumulatedPrice / (1 - profitRate1Double === 0 ? 1 : 1 - profitRate1Double)) - this.facttransCostAccumulatedPrice
    },
    profitRate1AccumulatedPrice: function () {
      return this.facttransCostAccumulatedPrice + this.profitRate1ItemPrice
    },
    // 販社A利益
    profitRate2ItemPrice: function () {
      let profitRate2Double = this.estimate.profitRate2 / 100
      return Math.round(this.profitRate1AccumulatedPrice / (1 - profitRate2Double === 0 ? 1 : 1 - profitRate2Double)) - this.profitRate1AccumulatedPrice
    },
    profitRate2AccumulatedPrice: function () {
      return this.profitRate1AccumulatedPrice + this.profitRate2ItemPrice
    },
    // 販社B利益
    profitRate3ItemPrice: function () {
      let profitRate3Double = this.estimate.profitRate3 / 100
      return Math.round(this.profitRate2AccumulatedPrice / (1 - profitRate3Double === 0 ? 1 : 1 - profitRate3Double)) - this.profitRate2AccumulatedPrice
    },
    profitRate3AccumulatedPrice: function () {
      return this.profitRate2AccumulatedPrice + this.profitRate3ItemPrice
    },
    // 販社C利益
    profitRate4ItemPrice: function () {
      let profitRate4Double = this.estimate.profitRate4 / 100
      return Math.round(this.profitRate3AccumulatedPrice / (1 - profitRate4Double === 0 ? 1 : 1 - profitRate4Double)) - this.profitRate3AccumulatedPrice
    },
    profitRate4AccumulatedPrice: function () {
      return this.profitRate3AccumulatedPrice + this.profitRate4ItemPrice
    },
    // 配送費
    deliveryCostAccumulatedPrice: function () {
      return this.profitRate4AccumulatedPrice + parseInt(this.estimate.deliveryCost)
    },
    // 施工費
    executionCostAccumulatedPrice: function () {
      return this.deliveryCostAccumulatedPrice + parseInt(this.estimate.executionCost)
    },
    // *****************************************************************
    // 見積金額、粗利(限界利益)、粗利益
    // *****************************************************************
    // 工場製造原価
    manufacturingCost: function () {
      return this.materialCostItemPrice + this.materialMagProbItemPrice + this.processCostItemPrice + this.productMagCostItemPrice
    },
    manufacturingGrossMargin: function () {
      return this.materialMagProbItemPrice + this.processCostItemPrice + this.productMagCostItemPrice
    },
    manufacturingGrossProfit: function () {
      let manuGrossProfit = this.manufacturingGrossMargin / this.manufacturingCost
      return Number.isNaN(manuGrossProfit) ? 0 : Math.round(manuGrossProfit * 100)
    },
    // 工場価格見積
    factoryCostEst: function () {
      return this.materialCostItemPrice + this.materialMagProbItemPrice + this.processCostItemPrice + this.productMagCostItemPrice +
        this.factoryProfitItemPrice + this.facttransCostItemPrice
    },
    factoryGrossMargin: function () {
      return this.materialMagProbItemPrice + this.processCostItemPrice + this.productMagCostItemPrice + this.factoryProfitItemPrice
    },
    factoryGrossProfit: function () {
      let factoryGrossProfit = this.factoryGrossMargin / this.factoryCostEst
      return Number.isNaN(factoryGrossProfit) ? 0 : Math.round(factoryGrossProfit * 100)
    },
    // 工場営業見積
    factorySalesEst: function () {
      return this.materialCostItemPrice + this.materialMagProbItemPrice + this.processCostItemPrice + this.productMagCostItemPrice +
        this.factoryProfitItemPrice + this.facttransCostItemPrice + this.profitRate1ItemPrice
    },
    factorySalesEstGrossMargin: function () {
      return this.materialMagProbItemPrice + this.processCostItemPrice + this.productMagCostItemPrice + this.factoryProfitItemPrice +
      this.profitRate1ItemPrice
    },
    factorySalesEstGrossProfit: function () {
      let factorySalesEstGrossProfit = this.factorySalesEstGrossMargin / this.factorySalesEst
      return Number.isNaN(factorySalesEstGrossProfit) ? 0 : Math.round(factorySalesEstGrossProfit * 100)
    },
    // 販社A見積
    salesCompanyA: function () {
      return this.materialCostItemPrice + this.materialMagProbItemPrice + this.processCostItemPrice + this.productMagCostItemPrice +
        this.factoryProfitItemPrice + this.facttransCostItemPrice + this.profitRate1ItemPrice + this.profitRate2ItemPrice
    },
    salesCompanyAGrossMargin: function () {
      return this.materialMagProbItemPrice + this.processCostItemPrice + this.productMagCostItemPrice + this.factoryProfitItemPrice +
        this.profitRate1ItemPrice + this.profitRate2ItemPrice
    },
    salesCompanyAGrossProfit: function () {
      let salesCompanyAGrossProfit = this.salesCompanyAGrossMargin / this.salesCompanyA
      return Number.isNaN(salesCompanyAGrossProfit) ? 0 : Math.round(salesCompanyAGrossProfit * 100)
    },
    // 販社B見積
    salesCompanyB: function () {
      return this.materialCostItemPrice + this.materialMagProbItemPrice + this.processCostItemPrice + this.productMagCostItemPrice +
        this.factoryProfitItemPrice + this.facttransCostItemPrice + this.profitRate1ItemPrice + this.profitRate2ItemPrice +
        this.profitRate3ItemPrice
    },
    salesCompanyBGrossMargin: function () {
      return this.materialMagProbItemPrice + this.processCostItemPrice + this.productMagCostItemPrice + this.factoryProfitItemPrice +
      this.profitRate1ItemPrice + this.profitRate2ItemPrice + this.profitRate3ItemPrice
    },
    salesCompanyBGrossProfit: function () {
      let salesCompanyBGrossProfit = this.salesCompanyBGrossMargin / this.salesCompanyB
      return Number.isNaN(salesCompanyBGrossProfit) ? 0 : Math.round(salesCompanyBGrossProfit * 100)
    },
    // 販社C見積
    salesCompanyC: function () {
      return this.materialCostItemPrice + this.materialMagProbItemPrice + this.processCostItemPrice + this.productMagCostItemPrice +
        this.factoryProfitItemPrice + this.facttransCostItemPrice + this.profitRate1ItemPrice + this.profitRate2ItemPrice +
        this.profitRate3ItemPrice + this.profitRate4ItemPrice
    },
    salesCompanyCGrossMargin: function () {
      return this.materialMagProbItemPrice + this.processCostItemPrice + this.productMagCostItemPrice + this.factoryProfitItemPrice +
      this.profitRate1ItemPrice + this.profitRate2ItemPrice + this.profitRate3ItemPrice + this.profitRate4ItemPrice
    },
    salesCompanyCGrossProfit: function () {
      let salesCompanyCGrossProfit = this.salesCompanyCGrossMargin / this.salesCompanyC
      return Number.isNaN(salesCompanyCGrossProfit) ? 0 : Math.round(salesCompanyCGrossProfit * 100)
    },
    // *****************************************************************
    // 帯グラフのデータ
    // *****************************************************************
    chartData: function () {
      return {
        labels: ['工場製造原価', '工場価格見積', '工場営業見積', '販社A見積', '販社B見積', '販社C見積'],
        datasets: [
          {
            label: '材料費',
            data: [this.materialCostItemPrice, this.materialCostItemPrice, this.materialCostItemPrice,
              this.materialCostItemPrice, this.materialCostItemPrice, this.materialCostItemPrice],
            backgroundColor: '#a6a6a6'
          },
          {
            label: '材料管理費',
            data: [this.materialMagProbItemPrice, this.materialMagProbItemPrice, this.materialMagProbItemPrice,
              this.materialMagProbItemPrice, this.materialMagProbItemPrice, this.materialMagProbItemPrice],
            backgroundColor: '#ed7c31'
          },
          {
            label: '加工費',
            data: [this.processCostItemPrice, this.processCostItemPrice, this.processCostItemPrice,
              this.processCostItemPrice, this.processCostItemPrice, this.processCostItemPrice],
            backgroundColor: '#fff2cc'
          },
          {
            label: '生産管理費',
            data: [this.productMagCostItemPrice, this.productMagCostItemPrice, this.productMagCostItemPrice,
              this.productMagCostItemPrice, this.productMagCostItemPrice, this.productMagCostItemPrice],
            backgroundColor: '#5b9ad5'
          },
          {
            label: '工場利益',
            data: [0, this.factoryProfitItemPrice, this.factoryProfitItemPrice,
              this.factoryProfitItemPrice, this.factoryProfitItemPrice, this.factoryProfitItemPrice],
            backgroundColor: '#70ad47'
          },
          {
            label: '輸送賃',
            data: [0, this.facttransCostItemPrice, this.facttransCostItemPrice,
              this.facttransCostItemPrice, this.facttransCostItemPrice, this.facttransCostItemPrice],
            backgroundColor: '#264478'
          },
          {
            label: '営業部門利益',
            data: [0, 0, this.profitRate1ItemPrice, this.profitRate1ItemPrice,
              this.profitRate1ItemPrice, this.profitRate1ItemPrice],
            backgroundColor: '#f9cbad'
          },
          {
            label: '販社A利益',
            data: [0, 0, 0, this.profitRate2ItemPrice, this.profitRate2ItemPrice,
              this.profitRate2ItemPrice],
            backgroundColor: '#636363'
          },
          {
            label: '販社B利益',
            data: [0, 0, 0, 0, this.profitRate3ItemPrice, this.profitRate3ItemPrice],
            backgroundColor: '#997300'
          },
          {
            label: '販社C利益',
            data: [0, 0, 0, 0, 0, this.profitRate4ItemPrice],
            backgroundColor: '#245e91'
          },
          {
            label: '配送費',
            data: [0, 0, 0, 0, 0, this.estimate.deliveryCost],
            backgroundColor: '#70ad47'
          },
          {
            label: '施工費',
            data: [0, 0, 0, 0, 0, this.estimate.executionCost],
            backgroundColor: '#698ed0'
          }
        ]
      }
    }
  },
  methods: {
  },
  mounted () {
  }
}

</script>

<style lang="scss" scoped>
.overview {
  margin-bottom: 8px;
}
.plan_name_id {
  width: 200px;
  line-height: 25px;
  display: inline-block;
  word-wrap: break-word;
}
.calc_description {
  display: inline-block;
  table {
    width: 853px;
    td {
      border: 1px solid #d2d2d2;;
      background: #F2F2F2;
      text-align: center;
      line-height: 12px;
      font-weight: normal;
    }
    .a_b_c_d_e {
      width: 59px;
    }
    .f {
      width: 62px;
    }
    .g {
      width: 82px;
    }
    .h_i_j {
      width: 68px;
    }
    .k_l {
      width: 67px;
    }
  }
}
.list {
  text-align: center;
  width: 1392px;
  td {
    border: none;
    background: #F2F2F2;
    font-weight: normal;
    text-align: right;
  }
  input {
    color: #305496;
    border-color: #305496;
    background-color: #FDF2CF;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-left: 1px;
    padding-right: 1px;
    text-align: center;
    border-radius: unset;
  }
  input:focus {
    outline: 0;
    box-shadow: none;
    border: 2px solid #089569;
  }
  .square {
    width: 36px;
    height: 20px;
    background: #FDF2CF;
    display: inline-block;
    vertical-align: sub;
    border: 2px solid #305496;
    margin-right: 5px;
  }
  // ******************************
  // セル
  // ******************************
  // 入力セル
  .input_area {
    padding: 0;
  }
  // 設定入力
  .setting_input {
    font-size: 15px;
    padding: 0;
  }
  // 設定入力の補足情報
  .setting_input_sub {
    font-size: 10px;
    height: 3px;
    line-height: 4px;
    text-align: center;
  }
  // BOM
  .bom {
    text-align: center;
  }
  // 項目
  .item {
    background: #E7E6E6;
    font-weight: bold;
    text-align: center;
    &.alias {
      text-align: left;
      font-size: 9px;
      padding-left: 6px;
    }
  }
  // 掛率の項目
  .prob {
    line-height: unset;
  }
  // セルの設定値
  .cell_setting {
    width: 205px;
    background: none;
    font-weight: bold;
    font-size: 16px;
    padding: 0;
    text-align: left;
  }
  // 生産
  .production {
    background: #D6DCE4;
    text-align: center;
    width: 340px;
  }
  // OEM見積
  .oem_est {
    background: #D6DCE4;
    text-align: center;
    width: 63px;
  }
  // メーカー見積
  .marker-est {
    background: #D6DCE4;
    text-align: center;
    width: 82px;
  }
  // 流通
  .distribution {
    background: #E2EFDA;
    text-align: center;
    width: 227px;
  }
  // 費用
  .cost {
    background: #FEF2EC;
    text-align: center;
    width: 146px;
  }
  // 空のセル
  .empty {
    background: #D9D9D9
  }
  // ******************************
  // 罫線
  // ******************************
  // 細い下罫線
  .border_bottom_thin {
    border-bottom: 1px solid #d2d2d2;
  }
  // 普通の下罫線
  .border_bottom_middle {
    border-bottom: 1px solid #808080;
  }
  // 太い下罫線
  .border_bottom_thick {
    border-bottom: 1px solid;
  }
  // 普通の上罫線
  .border_top_middle {
    border-top: 1px solid #808080;
  }
  // 細い右罫線
  .border_right_thin {
    border-right: 1px solid #d2d2d2;
  }
  // 普通の右罫線
  .border_right_middle {
    border-right: 1px solid #808080;
  }
  // 普通の左罫線
  .border_left_middle {
    border-left: 1px solid #808080;
  }
}
.graph {
  margin-bottom: 30px;
  background: #F2F2F2;
  margin-top: 15px;
  box-shadow: 10px 10px 10px grey;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/sheet/PriceFlow.vue